"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupedView = function GroupedView() {
  return _react2.default.createElement(
    "svg",
    { focusable: "false", "aria-hidden": true, className: "icon-svg-grouped-view", preserveAspectRatio: "xMinYMin meet", viewBox: "0 0 16 16" },
    _react2.default.createElement(
      "g",
      { fillRule: "evenodd" },
      _react2.default.createElement("rect", { width: "4", height: "4", y: "2", fillRule: "nonzero" }),
      _react2.default.createElement("rect", { width: "10", height: "2", x: "6", y: "3" }),
      _react2.default.createElement("rect", { width: "8", height: "2", x: "8", y: "8" }),
      _react2.default.createElement("rect", { width: "8", height: "2", x: "8", y: "13" }),
      _react2.default.createElement("rect", { width: "2", height: "10", x: "8", y: "5" })
    )
  );
};

exports.default = GroupedView;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/GroupedView/GroupedView.js
// module id = 192
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14